<template>
  <v-app>
    <v-card row align-center style="max-width: 400px;  width:100%;" class="mx-auto mt-5">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Forgot password?</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form @keyup.enter.native="reset()">
          <v-text-field
            color="primary"
            v-model="username"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @input="$v.username.$touch()"
            @blur="$v.username.$touch()"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" dark @click="reset()">Reset password</v-btn>
      </v-card-actions>
    </v-card>
  </v-app>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import firebase from "firebase";
export default {
  data() {
    return {
      username: "",
      user: null
    };
  },
  validations: {
    username: {
      required,
      email
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.email && errors.push("Must be valid e-mail");
      !this.$v.username.required && errors.push("E-mail is required");
      return errors;
    },
    color() {
      return this.$store.getters.appBaseColor;
    }
  },
   
  methods: {
    reset() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$store
        // .dispatch("verifyRecapthca", "forgottPassword")
        // .then(result => {
        //   if (result.data.errorMessage) {
        //     this._vm.showError(result.data.errorMessage);
        //   } else if (result.data.success) {
            firebase
              .auth()
              .sendPasswordResetEmail(this.username)
              .then(() => {
                
                // Email sent.
                this.showSuccess(
                  "Reset password e-mail sent to " + this.username
                );
                this.$router.push("/login");
              })
              .catch((error) => {
                this.showError(error.message);
              });
        //   }
        // });
    }
  },
  watch: {}
};
</script>

<style >
</style>
